import React, { useMemo } from "react";
import { useSlate, ReactEditor } from "slate-react";
import {
  getAbove,
  getParent,
  isDescendant,
  isAncestor,
} from "@udecode/slate-plugins";

import BaseElement from "../BaseElement";
import { isAlignBlock } from "../../editor-utils";

export function renderListElement(params) {
  return (props) => {
    if (props.element.type === "ul" || props.element.type === "ol") {
      return <ListElement {...props} {...params} />;
    }

    if (props.element.type === "li") {
      return <ListElementItem {...props} />;
    }

    if (props.element.type === "p") {
      return <ListElementItemText {...props} />;
    }

    return undefined;
  };
}

export default function ListElement({
  attributes,
  index,
  element,
  children,
  ...props
}) {
  const editor = useSlate();
  const renderList = () => {
    return element.type === "ol" ? <ol>{children}</ol> : <ul>{children}</ul>;
  };
  const path = ReactEditor.findPath(editor, element);
  const [parent] = getParent(editor, path);
  const isNested = path.length > 1 && !isAlignBlock(parent?.type);

  if (isNested) {
    return <div {...attributes}>{renderList()}</div>;
  }

  return (
    <BaseElement
      element={element}
      type={element.type}
      {...props}
      {...attributes}
    >
      {({ isEmpty }) => <React.Fragment>{renderList()}</React.Fragment>}
    </BaseElement>
  );
}

function ListElementItem(props) {
  return <li {...props} style={{ fontSize: props.element.fontSize }} />;
}

function ListElementItemText(props) {
  return <p {...props} />;
}
